// Popup "Đồng Hồ Báo Thức": nghe voice (1 audio chạy tại 1 thời điểm), tải file,
// nhân vật chưa tới mốc release thì bấm ra thông báo thay vì phát/tải.
window.addEventListener('load', function () {
  var $section = $('#cfl-ms-25-alarmclock');
  if (!$section.length) return;

  var audio = new Audio();
  var $playing = null;
  var $notice = $section.find('.notice');
  var noticeTimer = null;

  // Toast nổi GIỮA popup: hiện lên rồi tự ẩn. Không bám theo hàng vừa bấm — bấm hàng nào
  // cũng thấy ở cùng một chỗ dễ nhìn, không che nội dung hàng bên cạnh.
  function showNotice() {
    $notice.removeClass('active');
    // ép reflow để lần bấm liên tiếp chạy lại animation từ đầu thay vì đứng im
    void $notice[0].offsetWidth;
    $notice.addClass('active');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      $notice.removeClass('active');
    }, 2000);
  }

  // Chưa tới mốc mở (10:00 GMT+7) -> khoá hành vi, KHÔNG khoá giao diện nút
  function isLocked($item) {
    var open = $item.attr('data-open');
    if (!open) return false;
    var time = new Date(open).getTime();
    if (isNaN(time)) return false;
    return Date.now() < time;
  }

  function stopAudio() {
    audio.pause();
    audio.currentTime = 0;
    if ($playing) $playing.removeClass('playing');
    $playing = null;
  }

  $section.on('click', '.btn-listen', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $item = $btn.closest('.item');
    if (isLocked($item)) {
      stopAudio();
      showNotice($item);
      return false;
    }
    // bấm lại đúng nút đang phát -> dừng
    if ($playing && $playing[0] === $btn[0]) {
      stopAudio();
      return false;
    }
    stopAudio();
    audio.src = $item.attr('data-audio');
    var promise = audio.play();
    if (promise && promise.catch) promise.catch(function () {});
    $playing = $btn.addClass('playing');
    return false;
  });

  $section.on('click', '.btn-download', function (e) {
    var $item = $(this).closest('.item');
    if (isLocked($item)) {
      e.preventDefault();
      showNotice($item);
      return false;
    }
  });

  audio.addEventListener('ended', stopAudio);
  $section.find('.MJ__close-popup').on('click', stopAudio);
});
